import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const insertPressing = createAsyncThunk('insertPressing', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertPressEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const insertPressInward = createAsyncThunk('insertPressInward', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertPressInwardEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

// export const fetchStitchReturnOptions = createAsyncThunk('fetchStitchReturnOptions', async () => {
//     try {
//         const response = await axios.get(`${baseUrl}?apicall=getStitchOptionslist`);
//         return response.data;
//     } catch (error) {
//         throw error;
//     }
// });

export const fetchTrimMemoForPress = createAsyncThunk('fetchTrimMemoForPress', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getTrimMemoForPressing&firmId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPressEmplist = createAsyncThunk('fetchPressEmplist', async (id) => {
    try {
        const endpoint = id ? `getPressEmployee&empId=${id}` : 'getPressEmployee';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPressMemoNo = createAsyncThunk('fetchPressMemoNo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPressingMemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPressRegProduction = createAsyncThunk('fetchPressRegProduction', async (id) => {
    try {
        const endpoint = id ? `getPressRegister&prId=${id}` : 'getPressRegister';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchPressInwReg = createAsyncThunk('fetchPressInwReg', async (id) => {
    try {
        const endpoint = id ? `getPressInwardReg&prnId=${id}` : 'getPressInwardReg';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPressInwRegByPrId = createAsyncThunk('fetchPressInwRegByPrId', async (id) => {

    try {
        const endpoint = id ? `getPressInwardReg&prId=${id}` : 'getPressInwardReg';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        // console.log(response.data)
        return response.data;

    } catch (error) {
        throw error;
    }
});


const PressApiSlice = createSlice({
    name: 'PressDatalist',
    initialState: {
        isLoading: false,
        sreMemo: null,
        trnMemo: null,
        emplist: null,
        prMemo: null,
        prlist: null,
        prnlist: null,
        prlist2: null,
        isError: false
    },
    extraReducers: (builder) => {
        // builder.addCase(fetchStitchReturnOptions.pending, (state, action) => {
        //     state.isLoading = true;
        // });
        // builder.addCase(fetchStitchReturnOptions.fulfilled, (state, action) => {
        //     state.isLoading = false;
        //     state.sreMemo = action.payload;
        // });
        // builder.addCase(fetchStitchReturnOptions.rejected, (state, action) => {
        //     console.log('Error', action.error.message);
        //     state.isError = true;
        // });

        builder.addCase(fetchTrimMemoForPress.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchTrimMemoForPress.fulfilled, (state, action) => {
            state.isLoading = false;
            state.trnMemo = action.payload;
        });
        builder.addCase(fetchTrimMemoForPress.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchPressEmplist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPressEmplist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.emplist = action.payload;
        });
        builder.addCase(fetchPressEmplist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchPressMemoNo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPressMemoNo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.prMemo = action.payload;
        });
        builder.addCase(fetchPressMemoNo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchPressRegProduction.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPressRegProduction.fulfilled, (state, action) => {
            state.isLoading = false;
            state.prlist = action.payload;
        });
        builder.addCase(fetchPressRegProduction.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchPressInwReg.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPressInwReg.fulfilled, (state, action) => {
            state.isLoading = false;
            state.prnlist = action.payload;
        });
        builder.addCase(fetchPressInwReg.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchPressInwRegByPrId.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPressInwRegByPrId.fulfilled, (state, action) => {
            state.isLoading = false;
            state.prlist2 = action.payload;
        });
        builder.addCase(fetchPressInwRegByPrId.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default PressApiSlice.reducer;
